import { render, staticRenderFns } from "./ViewsTemplateMain.vue?vue&type=template&id=70fddb45&"
import script from "./ViewsTemplateMain.vue?vue&type=script&lang=js&"
export * from "./ViewsTemplateMain.vue?vue&type=script&lang=js&"
import style0 from "./ViewsTemplateMain.vue?vue&type=style&index=0&id=70fddb45&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports